import axios from "./api";
import TokenService from "./token.service";
import { refreshToken } from "../actions/auth";
import EventBus from "../common/EventBus";
import AuthService from "./auth.service";
import instance from "./api";

const setup = (store) => {


    axios.interceptors.request.use(
        (config) => {
            const token = TokenService.getLocalAccessToken();
            if (token) {
                config.headers["Authorization"] = 'Bearer ' + token;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const { dispatch } = store;

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    axios.interceptors.response.use(
        async (response) => {

            // Use the 202 response code as an indicator that polling is needed
            if (response.status === 202) {

                let location = response.headers.location;

                // Retrieve the initial operation status
                let pollingResponse = await instance.get(location);

                const maxAttempts = 10;
                let currentAttempts = 1;
                while(pollingResponse.data.status === "PROGRESS" && currentAttempts <= maxAttempts) {
                    await sleep(2000);
                    pollingResponse = await axios.get(location);
                    currentAttempts++
                }

                if (pollingResponse.data.status === "ERROR") {
                    // Treat failures as exceptions, so they can be handled as such
                    throw new Error('The status of the operation is in ERROR.');
                } else {
                    return response;
                }

            } else {
                return response;
            }
        },
        async (err) => {
            const originalConfig = err.config;

            if (err.response.status === 403 && originalConfig.url === '/auth/refresh-token') {

                AuthService.logout();

                EventBus.dispatch("logout");

                return Promise.reject(err);
            }

            if (originalConfig.url !== "/auth/sign-in" && err.response) {
                // Access Token was expired
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;

                    try {
                        const rs = await axios.post("/auth/refresh-token", {
                            refreshToken: TokenService.getLocalRefreshToken(),
                        });

                        const { accessToken } = rs.data;

                        dispatch(refreshToken(accessToken));

                        TokenService.updateLocalAccessToken(accessToken);

                        return axios({
                            ...originalConfig,
                            headers: originalConfig.headers.toJSON()
                        });

                    } catch (_error) {
                        return Promise.reject(_error);
                    }
                }
            }

            return Promise.reject(err);
        }
    );
};

export default setup;
